let allPDFTemlateList = [
  {
    id: 1,
    typeList: {
      mainInfo: [
        {
          canAdd: false,
        },
        {
          canAdd: false,
        },
        {
          canAdd: true,
        },
      ], //公司主体信息
      productList: [{ type: "single" }], //服务与产品
      projectList: [{ type: "single" }], //项目与案例
      honorList: [{ type: "multiple", maxLength: 4 }], //荣誉与认证
      memberList: [{ type: "multiple", maxLength: 4 }], //团队成员
      partnerList: [{ type: "multiple", maxLength: 16 }], //合作伙伴
      contact: [
        {
          canAdd: false,
          maxLength: 3,
        },
        {
          canAdd: true,
          maxLength: 9,
        },
      ], //联系方式页
    },
  },
  {
    id: 13,
    typeList: {
      mainInfo: [
        1,
        {
          isCover: true,
        },
        3,
      ], //公司主体信息
      productList: [{ type: "multiple", maxLength: 4, isCover: false }], //服务与产品
      projectList: [
        { type: "single", qrData: 42, isCover: true },
        { type: "single", qrData: 42, maxLength: 4 },
        { type: "single", qrData: 42, maxLength: 6 },
      ], //项目与案例
      honorList: [
        { type: "single", isCover: true },
        { type: "multiple", maxLength: 3 },
        { type: "multiple", maxLength: 3 },
      ], //荣誉与认证

      partnerList: [
        { type: "single", isCover: true },
        { type: "multiple", maxLength: 8 },
      ], //合作伙伴

      memberList: [
        { type: "single", isCover: true },
        { type: "multiple", maxLength: 3 },
      ], //团队成员
      contact: [1], //联系方式页
    },
  },
];

export default allPDFTemlateList;
